// Agent drops come from conferences.is_dropped, surfaced as
// dashboard_summary_periods.phone_inbound_dropped_count, so the Live dashboard reports the same
// rate as the heat report. The phone_missed_call_agent_dropped_* fields count callback tasks
// rather than calls and undercount any drop that never produced one.

export function adjustedAgentDropRate(summary: any): number {
    const dropped = (summary?.phone_inbound_dropped_count || 0) - (summary?.phone_missed_call_agent_dropped_contact_count || 0);
    return dropRate(dropped, summary?.phone_inbound_call_count);
}

export function agentDropRate(summary: any): number {
    return dropRate(summary?.phone_inbound_dropped_count, summary?.phone_inbound_call_count);
}

export function dropRate(dropped: number, inboundCalls: number): number {
    if (!(dropped > 0) || !(inboundCalls > 0)) {
        return 0;
    }
    return (dropped / inboundCalls) * 100.0;
}
